import React, {useState} from 'react';
import {useNotify, useRefresh} from 'react-admin';
import {clearGetListCache} from '../dataProvider';
import {postPalletAdjustment} from '../utils/apiFunctions';
import PalletQtyEditDialog from './PalletQtyEditDialog';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles({
    btn: {
        padding: 2,
        marginLeft: 4,
        verticalAlign: 'middle'
    }
});

/**
 * A component for adjusting a Client's Pallet Count from a Dialog
 *
 * The Dialog collects a new count; the API records a signed delta and derives
 * the running total, so the difference is what is posted.
 *
 * @param record
 * @return {JSX.Element}
 * @constructor
 */
const PalletQtyEdit = ({record}) => {

    const [openDialog, setOpenDialog] = useState(false);
    const [saving, setSaving] = useState(false);
    const classes = useStyles();
    const notify = useNotify();
    const refresh = useRefresh();

    if (!record || !record.id) {
        return null;
    }

    const handleEditClick = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        setSaving(false);
    };

    const handleSave = (e) => {
        setSaving(true);
        postPalletAdjustment({org_id: record.id, qty: e.qty, info: e.info, notes: e.notes})
            .then((result) => {
                setSaving(false);
                if (result && result.id) {
                    setOpenDialog(false);
                    notify((e.qty === 0)
                        ? 'Pallet notes updated.'
                        : `Pallet count updated to ${result.total}.`, 'info');
                    // Allow the list to re-fetch rather than be dropped as a repeat call
                    clearGetListCache();
                    refresh();
                } else {
                    notify('Sorry, there was an error updating this pallet count.', 'warning');
                }
            })
            .catch((error) => {
                setSaving(false);
                notify('Sorry, there was an error updating this pallet count.', 'warning');
            });
    };

    return (
        <>
            <IconButton
                aria-label="Edit Pallet Count"
                title="Edit Pallet Count"
                className={classes.btn}
                onClick={() => handleEditClick()}
            >
                <EditIcon/>
            </IconButton>
            <PalletQtyEditDialog
                openDialog={openDialog}
                record={record}
                saving={saving}
                onCloseFunc={handleClose}
                onSaveFunc={(e) => handleSave(e)}
            />
        </>
    );
}

export default PalletQtyEdit;
